import { forwardRef, useEffect, useState } from 'react'
import { Box, NumberInput as MantineNumberInput } from '@mantine/core'

import type { NumberInputProps } from '@/components/NumberInput/NumberInput.types'

import classes from './NumberInput.module.css'

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  (
    { containerProps, onChange, thousandSeparator = ',', value, ...props },
    ref,
  ) => {
    const [localValue, setLocalValue] = useState(value || '')

    const handleChange = (value: string | number) => {
      onChange?.(value)

      setLocalValue(value)
    }

    useEffect(() => {
      setLocalValue(value ?? '')
    }, [value])

    return (
      <Box {...containerProps}>
        <MantineNumberInput
          ref={ref}
          className={classes.numberInput}
          onChange={handleChange}
          thousandSeparator={thousandSeparator}
          value={localValue}
          {...props}
        />
      </Box>
    )
  },
)
